import React from 'react';
import Search from './components/Search';
import FirmwareTypeSelect from './components/FirmwareTypeSelect';
import ResetBtn from './components/ResetBtn';
import UnassignedCheckbox from './components/UnassignedCheckbox';
import AssignBtn from './components/AssignBtn';
import style from './FirmwareControlPanel.module.scss';

const FirmwareControlPanel: React.FC = () => {
	return (
		<div data-test="FirmwareControlPanel">
			<Search />
			<div className={style.firstControlUnit}>
				<FirmwareTypeSelect />
				<ResetBtn />
			</div>
			<div className={style.secondControlUnit}>
				<UnassignedCheckbox />
				<AssignBtn />
			</div>
		</div>
	);
};

export default FirmwareControlPanel;
